var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container"},[_c('van-icon',{staticClass:"header-bar-btn",attrs:{"name":"bars"},on:{"click":_vm.handleClick}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }